function catalogRowForHandle(byHandle, shopifyHandle) {
  if (!shopifyHandle) return null;
  const direct = byHandle.get(shopifyHandle);
  if (direct) return direct;
  const norm = String(shopifyHandle).toLowerCase();
  if (norm.includes('fasciablade')) {
    for (const [h, row] of byHandle) {
      if (String(h).toLowerCase().includes('fasciablade')) return row;
    }
  }
  return null;
}

/**
 * Match Shopify catalog rows to curated homepage rows by `handle` (exact string from Shopify).
 */
export function enrichHomepageLineup(template, catalog) {
  if (!catalog || !Array.isArray(catalog) || catalog.length === 0) {
    return template.map((item) => ({
      ...item,
      price: null,
      compareAt: null,
    }));
  }
  const byHandle = new Map(catalog.map((p) => [p.handle, p]));
  return template.map((item) => {
    const row = catalogRowForHandle(byHandle, item.shopifyHandle);
    if (!row) {
      return { ...item, price: null, compareAt: null };
    }
    const priceNum =
      typeof row.price === 'number' ? row.price : parseFloat(String(row.price ?? '').replace(/,/g, ''));
    const compareRaw = row.compare_at_price;
    const compareNum =
      compareRaw == null || compareRaw === ''
        ? null
        : typeof compareRaw === 'number'
          ? compareRaw
          : parseFloat(String(compareRaw).replace(/,/g, ''));
    return {
      ...item,
      price: Number.isFinite(priceNum) && priceNum > 0 ? priceNum : null,
      compareAt: Number.isFinite(compareNum) && compareNum > 0 ? compareNum : null,
      image: row.image || item.image,
    };
  });
}

export function getThermaCubeRowFromCatalog(catalog) {
  if (!catalog?.length) return null;
  return catalog.find((p) => p.handle === 'thermacube-hot-cold-therapy-device') ?? null;
}
